import React, { useState } from 'react';
import QuickOrderPanel from './QuickOrderPanel';

interface Props { prefillPrice?: number; }

export default function FloatingOrderFAB({ prefillPrice }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Expanded order panel — appears above the FAB */}
      {open && (
        <div style={{
          position: 'fixed', bottom: 153, right: 24, zIndex: 9000,
          width: 288,
          boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
          borderRadius: 10,
          animation: 'fabPanelIn 0.18s ease-out',
        }}>
          <QuickOrderPanel prefillPrice={prefillPrice} />
        </div>
      )}

      {/* FAB button */}
      <button
        onClick={() => setOpen(o => !o)}
        title={open ? 'Close order form' : 'Quick order'}
        style={{
          position: 'fixed', bottom: 87, right: 24, zIndex: 9001,
          width: 52, height: 52, borderRadius: '50%',
          backgroundColor: open ? '#2a3540' : '#4da3ff',
          border: '2px solid rgba(255,255,255,0.1)',
          color: 'white', fontSize: 24, lineHeight: 1, cursor: 'pointer',
          boxShadow: open ? '0 4px 16px rgba(0,0,0,0.4)' : '0 4px 20px rgba(77,163,255,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background 0.15s, box-shadow 0.15s, transform 0.2s',
          transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
        }}
      >
        +
      </button>

      <style>{`
        @keyframes fabPanelIn {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
}
